import {
    FETCH_ADAPTIVE_PLAN_FEED_SUCCESS,
    FETCH_ADAPTIVE_PLAN_FEED,
    FETCH_ADAPTIVE_PLAN_FEED_ERROR,
    FETCHING_ADAPTIVE_PLAN_FEED
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    isError: false,
    entities: []
};

const fetchingAdaptiveTrainingPlanFeed = (state, action) => {
    return {
        isFetching: true,
        isError: false,
        entities: []
    };
};

const fetchAdpativeTrainingPlanFeedError = (state, action) => {
    return {
        isFetching: false,
        isError: true,
        entities: []
    };
};

const fetchAdpativeTrainingPlanFeedSuccess = (state, action) => {
    return {
        isFetching: false,
        isError: false,
        entities: [...action.atpFeed]
    };
};

export const isFetchingFeed = (state) => {
    return state.atpFeed.isFetching;
};

export const isFetchingFeedError = (state) => {
    return state.atpFeed.isError;
};

export const getFeed = (state) => {
    return [...state.atpFeed.entities];
};

const handlers = {
    [FETCH_ADAPTIVE_PLAN_FEED_SUCCESS]: fetchAdpativeTrainingPlanFeedSuccess,
    [FETCH_ADAPTIVE_PLAN_FEED_ERROR]: fetchAdpativeTrainingPlanFeedError,
    [FETCHING_ADAPTIVE_PLAN_FEED]: fetchingAdaptiveTrainingPlanFeed
};

export default function atpFeed(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export function fetchAdaptiveTrainingPlanFeed(athletePlanId, lang) {
    return {
        type: FETCH_ADAPTIVE_PLAN_FEED,
        payload: {
            athletePlanId,
            lang
        }
    };
}
